import { useSyncExternalStore } from 'react'
import { storageHealth } from './index'

export function useStorageHealth() {
  return useSyncExternalStore(
    storageHealth.subscribe,
    storageHealth.getSnapshot,
    storageHealth.getSnapshot,
  )
}
